import {
  createComponentExtension,
  createPlugin,
} from '@backstage/core-plugin-api';

// NOTE: the jiraMyTasksApiRef factory is registered at the app level in
// packages/app/src/apis.ts, not here. This plugin only contributes a
// component extension (MyOpenTasksCard) mounted inside MyDayPage; Backstage's
// plugin collector only discovers plugins from route-level elements, so a
// factory declared in this plugin's `apis` would never be installed.
export const jiraMyTasksPlugin = createPlugin({
  id: 'jira-my-tasks',
});

/**
 * Card listing the current user's open Jira issues.
 * Designed to be mounted as a grid item on the My Day page.
 */
export const MyOpenTasksCard = jiraMyTasksPlugin.provide(
  createComponentExtension({
    name: 'MyOpenTasksCard',
    component: {
      lazy: () =>
        import('./components/MyOpenTasksCard').then(m => m.MyOpenTasksCard),
    },
  }),
);
